<!-- eslint-disable vue/no-mutating-props -->
<template>
    <Dialog v-model:visible="editItemDialog" :style="{width: '450px'}" header="Data Detail" :modal="true" class="p-fluid">
        <div class="field">
            <label>Industry</label>
            <Dropdown  dataKey="industry_id" 
                    ref="dindustry" v-model="industry_id_new" 
                    :loading="loadingDropdownIndustry" 
                    :options="dataDropdownIndustry" 
                    :class="{ 'p-invalid': errorEdit.industry_id_new }" 
                    optionLabel="industry_name" optionValue="industry_id" 
                    placeholder="Select Industry" :filter="true" 
                    :showClear="true" @filter="searchDropdownIndustry($event,'edit')"
            />
            <small class="p-invalid" style="color: red" v-if="errorEdit.industry_id_new" >{{ errorEdit.industry_id_new[0] }}</small>
        </div>
        <template #footer>
            <Button label="Cancel" icon="pi pi-times" class="p-button-text" @click="hideDialog"/>
            <Button label="Save" icon="pi pi-check" class="p-button-text" @click="updateItem" :loading="loading"/>
        </template>
    </Dialog>
</template>


<script>

import { mapGetters } from "vuex";

export default {
    props: [
		"item",
    ],
    data() {
        return {
            // loading
            loading: false,
            loadingDropdownIndustry: false,

            // dataDropdown
            dataDropdownIndustry: null,

            industry_id_old: null,
            industry_id_new: null,

            // edit
            editItemDialog: false,
        }
    },
    mounted() {
        this.$store.commit('setErrorEdit', {});
    },
    watch: {
        editItemDialog: {
            handler() {
                setTimeout(() => {
                    if(this.editItemDialog == true){
                        this.searchDropdownIndustry('', 'edit', this.item.industry_name);
                        this.industry_id_old = this.item.industry_id;
                        this.industry_id_new = this.item.industry_id;
                    }
                    this.$store.commit('setErrorEdit', {});
                }, 500);
            },
        }
    },
    computed:{
        ...mapGetters(['errorEdit']),
    },
    methods: {
        // DROPDOWN
        searchDropdownIndustry(event, purpose, valueEdit) {
            setTimeout(() => {

                if (valueEdit) {
                    this.$refs.dindustry.filterValue = valueEdit;
                }

                if (purpose == "edit") {
                    this.loadingDropdownIndustry = true;
                }

                this.axios({
                    method: 'GET',
                    url: process.env.VUE_APP_ROOT_API + 'web/select2/master-industry',
                    params: {
                        "search": valueEdit ? valueEdit : event.value,
                    }
                })
                .then(res => {

                    if (purpose == "edit") {
                        this.dataDropdownIndustry = res.data.data;
                        this.loadingDropdownIndustry = false;
                    } else if (purpose == null) {
                        this.dataDropdownIndustry = res.data.data;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            }, 250);
        },
        // EDIT
		hideDialog() {
			this.editItemDialog = false;
		},
		updateItem() {
            this.loading = true;

            this.axios({
                method: 'POST',
                url: process.env.VUE_APP_ROOT_API + 'web/master-industry/update',
                data: {
                    "industry_id_new" : this.industry_id_new,
                    "industry_id_old" : this.industry_id_old,
                },
            })
            .then((res) => {
                this.loading = false;
                if (res) {
                    this.$toast.add({ severity: 'success', summary: 'Successful', detail: 'Data Successfully Update', life: 3000,});
                    this.$store.commit('setErrors', {});
                    this.$store.commit('setErrorEdit', {});
                    // this.item = {};
                    this.editItemDialog = false;
                    this.$emit('submit');
                }
            })
            .catch((err) => {
                console.log(err);
                this.loading = false;
                this.$store.commit('setErrorEdit', err.response.data.data ? err.response.data.data : {});
                this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Data Failed to Update', life: 3000,});
            });
		},
    }
}
</script>